import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_API_URL } from "../../../../core/environment.tokens";

@Injectable()
export class DataExtractService {

  constructor(
    @Inject(BASE_API_URL) private readonly baseApiUrl: string,
    private http: HttpClient
  ) { }

  generateDataExtract(dataExportRequest): Observable<{}> {
    const url = `${this.baseApiUrl}dataexport/generate`;
    return this.http.post(url, dataExportRequest);
  }
}
